import { useState } from "react";
import { Helmet } from "react-helmet-async";
import gallery from "../../data/gallery";
import PageBanner from "../../components/layout/PageBanner";
import PlaceholderImage from "../../components/common/PlaceholderImage";
import Lightbox from "../../components/common/Lightbox";
import "./Gallery.css";

const CATEGORIES = ["All", "Gym Interior", "Equipment", "Training", "Members", "Events"];

export default function Gallery() {
  const [filter, setFilter] = useState("All");
  const [activeIndex, setActiveIndex] = useState(null);

  const visible = filter === "All" ? gallery : gallery.filter((g) => g.category === filter);

  return (
    <>
      <Helmet>
        <title>Gallery | Firm Fit Factory Peelamedu, Coimbatore</title>
        <meta name="description" content="Browse photos of the Firm Fit Factory gym floor, equipment, training sessions, members and events in Peelamedu, Coimbatore." />
        <link rel="canonical" href="https://www.firmfitfactory.com/gallery" />
      </Helmet>

      <PageBanner eyebrow="Gallery" title="Inside The Factory" description="A visual look at our floor, equipment and community. Real client-authorized photography will replace these placeholders." />

      <section className="section gallery-page">
        <div className="container">
          <div className="gallery-page__filters" role="tablist" aria-label="Filter gallery by category">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                type="button"
                role="tab"
                aria-selected={filter === c}
                className={`gallery-page__filter ${filter === c ? "gallery-page__filter--active" : ""}`}
                onClick={() => setFilter(c)}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="gallery-page__masonry">
            {visible.map((item, i) => (
              <button
                type="button"
                className="gallery-page__item"
                key={item.id}
                onClick={() => setActiveIndex(i)}
                aria-label={`Open image: ${item.alt}`}
              >
                {/* <PlaceholderImage tone={item.tone} alt={item.alt} ratio={i % 3 === 1 ? "3/4" : "4/3"} /> */}
                <img src={item.img} alt="" />
                {/* <span className="gallery-page__item-tag">{item.category}</span> */}
              </button>
            ))}
          </div>
        </div>
      </section>

      {activeIndex !== null && (
        <Lightbox
          items={visible}
          activeIndex={activeIndex}
          onClose={() => setActiveIndex(null)}
          onPrev={() => setActiveIndex((i) => (i - 1 + visible.length) % visible.length)}
          onNext={() => setActiveIndex((i) => (i + 1) % visible.length)}
        />
      )}
    </>
  );
}
